module.exports = __webpack_public_path__ + "static/media/arrow-white.bd4e2632.svg";